import { ICellEditorParams } from 'ag-grid-community';
import { Select, message } from 'antd';
import { forwardRef, useImperativeHandle, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';

import { ProductSupplier } from 'src/hooks/subscription/useProductInventoriesWithDetail';

interface Props extends ICellEditorParams {
  productSuppliers: ProductSupplier[];
  onUpdate: (supplierId: string) => Promise<void>;
}

const AgCellProductSupplierSelect = forwardRef<any, Props>((props, ref) => {
  const { value, productSuppliers, onUpdate, stopEditing } = props;
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value?.name);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return selectedValue;
      },
    };
  });

  return (
    <Select
      showSearch
      style={{ width: '100%' }}
      value={selectedValue}
      placeholder='거래처 선택'
      optionFilterProp='children'
      onChange={async (_, option: any) => {
        setSelectedValue(option.value);
        const supplier = productSuppliers.find((s) => s.name === option.value);
        try {
          if (!supplier) {
            throw new Error('거래처 찾을 수 없음');
          }
          await onUpdate(supplier._id);
          message.success('거래처 변경 완료');
          stopEditing();
        } catch (error) {
          console.error(error);
          const errorMessage = errorObjectToString(error);
          message.error(`거래처 변경 실패: ${errorMessage}`);
        }
      }}
      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
      options={productSuppliers.map((supplier) => ({
        value: supplier.name,
        label: supplier.name,
      }))}
    />
  );
});

AgCellProductSupplierSelect.displayName = 'AgCellProductSupplierSelect';

export default AgCellProductSupplierSelect;
